import script from "./CustomResourceApplyXYR.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyXYR.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyXYR.vue?vue&type=style&index=0&id=e4f86fd4&lang=less&scope=true"

const __exports__ = script;

export default __exports__